import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../helpers/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImageGalleryComponent } from '../shared/image-gallery/image-gallery.component';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { SharedComponentsModule } from '../shared-components.module';
import { CaseworkerRoutingModule } from './caseworker-routing.module';
import { BusinessentityComponent } from './caseworker/businessentity/businessentity.component';
import { BulkComponent } from './caseworker/bulk/bulk.component';
import { InterestComponent } from './caseworker/interest/interest.component';
import { FaqComponent } from './caseworker/faq/faq.component';
import { ReportComponent } from './caseworker/report/report.component';
import { PushmessagesComponent } from './caseworker/pushmessages/pushmessages.component';
import { CampaignComponent } from './caseworker/campaign/campaign.component';
import { TicketComponent } from './caseworker/ticket/ticket.component';
import { NewsComponent } from './caseworker/news/news.component';
import { TruncateModule } from '../../pipes/truncate.module';
import { TranslateStateModule } from '../../pipes/translate-state.module';
import { TranslateFilterModule } from '../../pipes/translate-filter.module';
import { NgxDropzoneModule } from 'ngx-dropzone';

import { MandantLogoModule } from '../shared/mandant-logo/mandant-logo.module';

import { AddComponentBusinessentity } from './caseworker/businessentity/add/add.component'
import { AddPushMessageComponent } from './caseworker/pushmessages/add/add.component'
import { EditComponentBusinessentity } from './caseworker/businessentity/edit/edit.component';
import { MembersComponent } from './caseworker/businessentity/members/members.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UserReportComponent } from './caseworker/user-report/user-report.component';
import { EditComponentPushMessage } from './caseworker/pushmessages/edit/edit.component';
import { AddComponentInterest } from './caseworker/interest/add/add.component';
import { AddFAQComponent } from './caseworker/faq/add-faq/add-faq.component';
import { EditFAQComponent } from './caseworker/faq/edit-faq/edit-faq.component';
import { RssFeedComponent } from './caseworker/rss-feed/rss-feed.component';
import { AddRssFeedComponent } from './caseworker/rss-feed/add-rss-feed/add-rss-feed.component';
import { EditRssFeedComponent } from './caseworker/rss-feed/edit-rss-feed/edit-rss-feed.component';
import { TasksComponent } from './caseworker/tasks/tasks.component';
import { EditInterestComponent } from './caseworker/interest/edit-interest/edit-interest.component';
import { AddNewsComponent } from './caseworker/news/add-news/add-news.component';
import { EditNewsComponent } from './caseworker/news/edit-news/edit-news.component'
import { AdvertisingBoxComponent } from './caseworker/advertising-box/advertising-box.component';
import { EditAdvertisingBoxComponent } from './caseworker/advertising-box/edit-advertising-box/edit-advertising-box.component';
import { AddAdvertisingBoxComponent } from './caseworker/advertising-box/add-advertising-box/add-advertising-box.component';
import { ChartsModule } from "@carbon/charts-angular";
import { AccountoptionsComponent } from './caseworker/accountoptions/accountoptions.component';
import { EditAccountoptionsComponent } from './caseworker/accountoptions/edit-accountoptions/edit-accountoptions.component';
import { BaseDataReportComponent } from './caseworker/base-data-report/base-data-report.component';
import { EditMembersComponent } from './caseworker/businessentity/members/edit/edit.component';
import { AddMemberComponent } from './caseworker/businessentity/members/add/add.component';
import { EditContractComponent } from './caseworker/dashboard/contracts/edit/edit.component';
import { MeasureEditComponent } from './caseworker/ticket/measure-edit/measure-edit.component';
import { BankDetailsEditComponent } from './caseworker/ticket/bank-details-edit/bank-details-edit.component';
import { PartPaymentEditComponent } from './caseworker/ticket/part-payment-edit/part-payment-edit.component';
import { InquiryEditComponent } from './caseworker/ticket/inquiry-edit/inquiry-edit.component';
import { RelocationEditComponent } from './caseworker/ticket/relocation-edit/relocation-edit.component';
import { RelocationV2EditComponent } from './caseworker/ticket/relocation-v2-edit/relocation-v2-edit.component';
import { MasterdataEditComponent } from './caseworker/ticket/masterdata-edit/masterdata-edit.component';
import { SignUpEditComponent } from './caseworker/ticket/sign-up-edit/sign-up-edit.component';
import { PhotovoltaikEditComponent } from './caseworker/ticket/photovoltaik-edit/photovoltaik-edit.component';
import { AdventCalendarComponent } from './caseworker/advent-calendar/advent-calendar.component';
import { AccountoptionsModule } from './caseworker/accountoptions/accountoptions.module';
import { EventPreviewMobileComponent } from './caseworker/event/event-preview-mobile/event-preview-mobile.component';
import { EventPreviewCardComponent } from './caseworker/event/event-preview-card/event-preview-card.component';
import { ClubstateComponent } from './caseworker/clubstate/clubstate.component';
import { PartnerreportModule } from './caseworker/partnerreport/partnerreport.module';
import { HouseholdModule } from './caseworker/household/household.module';
import { HouseholdComponent } from './caseworker/household/household.component';
import { UserDataComponent } from './caseworker/report/user-data/user-data.component';
import { DonutDataComponent } from './caseworker/report/donut-data/donut-data.component';
import { CalendarDataComponent } from './caseworker/report/calendar-data/calendar-data.component';
import { PositionComponent } from './caseworker/position/position.component';
import { AppointmentModule } from './caseworker/appointment/appointment.module';
import { AppointmentComponent } from './caseworker/appointment/appointment.component';
import { AddAppointmentComponent } from './caseworker/appointment/add-appointment/add-appointment.component';
import { EditAppointmentComponent } from './caseworker/appointment/edit-appointment/edit-appointment.component';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
    declarations: [
        ImageGalleryComponent,
        BusinessentityComponent,
        InterestComponent,
        FaqComponent,
        ReportComponent,
        PushmessagesComponent,
        CampaignComponent,
        TicketComponent,
        NewsComponent,
        AddComponentBusinessentity,
        EditComponentBusinessentity,
        MembersComponent,
        EventPreviewCardComponent,
        EventPreviewMobileComponent,
        AddPushMessageComponent,
        UserReportComponent,
        EditComponentPushMessage,
        AddComponentInterest,
        AddFAQComponent,
        EditFAQComponent,
        RssFeedComponent,
        AddRssFeedComponent,
        EditRssFeedComponent,
        TasksComponent,
        EditInterestComponent,
        AddNewsComponent,
        EditNewsComponent,
        AdvertisingBoxComponent,
        EditAdvertisingBoxComponent,
        AddAdvertisingBoxComponent,
        AccountoptionsComponent,
        EditAccountoptionsComponent,
        BaseDataReportComponent,
        EditMembersComponent,
        AddMemberComponent,
        EditContractComponent,
        MeasureEditComponent,
        BankDetailsEditComponent,
        PartPaymentEditComponent,
        InquiryEditComponent,
        RelocationEditComponent,
        RelocationV2EditComponent,
        MasterdataEditComponent,
        SignUpEditComponent,
        PhotovoltaikEditComponent,
        AdventCalendarComponent,
        ClubstateComponent,
        HouseholdComponent,
        UserDataComponent,
        DonutDataComponent,
        CalendarDataComponent,
        HouseholdComponent,
        UserDataComponent,
        DonutDataComponent,
        CalendarDataComponent,
        PositionComponent,
        AppointmentComponent,
        AddAppointmentComponent,
        EditAppointmentComponent,
    ],
    imports: [
        CommonModule,
        CaseworkerRoutingModule,
        AppMaterialModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        FormsModule,
        SharedPipesModule,
        SharedComponentsModule,
        TruncateModule,
        TranslateStateModule,
        TranslateFilterModule,
        NgxDropzoneModule,
        MandantLogoModule,
        DragDropModule,   
        ChartsModule,
        SharedPipesModule, 
        AccountoptionsModule,
        PartnerreportModule,
        HouseholdModule,
        CKEditorModule
    ]
})
export class CaseworkerModule {

}
